import AbstractValue from "./AbstractValue";

class FlatValue extends AbstractValue
{

}

export default FlatValue;
